<script setup>
import TimePicker from '../RealTimeInterface/TimePicker.vue'

</script>

<template>
    <section>
        <div class="container">
            <TimePicker/>
        </div>
    </section>
</template>
